import { render } from "./LanguageView.vue?vue&type=template&id=13cc0595&scoped=true&ts=true"
import script from "./LanguageView.vue?vue&type=script&lang=ts"
export * from "./LanguageView.vue?vue&type=script&lang=ts"

import "./LanguageView.vue?vue&type=style&index=0&id=13cc0595&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cc0595"]])

export default __exports__